import http from './http-common';

class UserReplicateService {
  userReplicate(data) {
    return http.post('/UserReplicate',data);
  }
}

export default new UserReplicateService();
